// services/recipientPayoutService.ts
//
// Reversements (RECIPIENT_PAYOUT_API) — read-only listing surfaced in
// the merchant dashboard. Backend endpoints live in
// backend-merchant/app/routers/recipient_payouts_router.py.
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3944";

export interface RecipientPayoutEligibilityResponse {
  has_recipient_payout_access: boolean;
}

export interface RecipientPayoutItem {
  reference: string;
  merchant_reference: string | null;
  recipient_id: string | null;
  recipient_name: string | null;
  recipient_phone: string | null;
  method: string | null;
  amount: number;
  currency: string;
  status: string;
  switch_reference: string | null;
  telco_reference: string | null;
  rejected_reason: string | null;
  description: string | null;
  created_at: string | null;
  completed_at: string | null;
}

export interface RecipientPayoutListResponse {
  items: RecipientPayoutItem[];
  page: number;
  page_size: number;
  total: number;
}

export interface RecipientPayoutListParams {
  status?: string;
  method?: string;
  search?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  page_size?: number;
}

function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const recipientPayoutService = {
  async checkEligibility(): Promise<RecipientPayoutEligibilityResponse> {
    const resp = await axios.get<RecipientPayoutEligibilityResponse>(
      `${API_URL}/merchants/recipient-payout/eligibility`,
      { timeout: 5000, headers: { ...getAuthHeaders(), "Cache-Control": "no-cache" } },
    );
    return resp.data;
  },

  async list(params: RecipientPayoutListParams = {}): Promise<RecipientPayoutListResponse> {
    const resp = await axios.get<RecipientPayoutListResponse>(
      `${API_URL}/merchants/recipient-payouts`,
      { timeout: 15000, headers: getAuthHeaders(), params },
    );
    return resp.data;
  },

  async getOne(reference: string): Promise<RecipientPayoutItem> {
    const resp = await axios.get<RecipientPayoutItem>(
      `${API_URL}/merchants/recipient-payouts/${encodeURIComponent(reference)}`,
      { timeout: 10000, headers: getAuthHeaders() },
    );
    return resp.data;
  },
};
